import { createStackUrl } from "@app/routes";
import { Banner } from "@app/ui/shared/banner";
import { Link } from "react-router-dom";
import { CONTROLS_EVENTS, controlsEvent } from "./tuna-events";

export const DedicatedStackBanner = () => {
  return (
    <Banner variant="error" iconAlign="center">
      <p className="font-semibold">
        Warning: Your infrastructure is not compliant
      </p>
      <p className="mt-1">
        All of your infrastructure (apps &amp; databases) on Aptible is
        currently deployed on shared stacks. Upgrade to a Dedicated Stack to
        achieve compliance with frameworks such as HIPAA, HITRUST, and more.{" "}
        <Link
          to={createStackUrl()}
          className="underline"
          onClick={() =>
            controlsEvent(CONTROLS_EVENTS.PROVISION_DEDICATED_STACK_CLICK)
          }
        >
          Provision a Dedicated Stack
        </Link>
      </p>
    </Banner>
  );
};

const STACKS_DOCS_URL =
  "https://www.aptible.com/docs/core-concepts/architecture/stacks";

export const DevelopmentScopeWarning = () => {
  return (
    <Banner variant="warning" iconAlign="center">
      <p className="font-semibold">Warning: Environments in shared stacks</p>
      <p className="mt-1">
        The selected environments are in shared stacks. Shared stacks are not
        designed for production and have limited security and compliance
        controls. Do not store or process sensitive or regulated data on shared
        stacks.{" "}
        <a
          href={STACKS_DOCS_URL}
          target="_blank"
          rel="noreferrer"
          className="underline"
        >
          View docs
        </a>
      </p>
    </Banner>
  );
};
